import React from 'react';
import PropTypes from 'prop-types';
import { StepperV2 } from '@atlas/ui';

const Stepper = ({ stepsAmount, activeStep }) => {
  const steps = Array.from({ length: stepsAmount }, (_, index) => index.toString());

  return (
    stepsAmount > 1 && (
      <div className="stepper-wrapper">
        <StepperV2 activeStep={activeStep} fakeLastStep>
          {steps.map(id => (
            <StepperV2.Step key={id}>
              <StepperV2.StepLabel />
            </StepperV2.Step>
          ))}
        </StepperV2>
      </div>
    )
  );
};

Stepper.propTypes = {
  stepsAmount: PropTypes.number.isRequired,
  activeStep: PropTypes.number.isRequired,
};

export default Stepper;
